import { useT } from './i18n';
// Shown only if a navigation takes >200 ms (e.g. cold load resolving the session), so fast loads don't flash.
export function Pending() {
  const t = useT();
  return <div role="status" aria-label={t.common.loading} className="grid min-h-dvh place-items-center"><span className="size-2 animate-pulse rounded-full bg-graphite" /></div>;
}
